// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"543":"c3d87239","682":"b0e73d1b","855":"8acc8bd1"}[chunkId] + ".js";
};